// extracted by mini-css-extract-plugin
module.exports = {"main":"error_main__icdsq","svg1":"error_svg1__974w4","svg":"error_svg__o3JRi","hue-rotate":"error_hue-rotate__AGXkG","oops":"error_oops__Phk1F","btn":"error_btn__xHKxE"};